module.exports = __webpack_public_path__ + "img/ef_detail_more_b_twpng.7859524d.png";